import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'cherryTrunk', d: 'M0,-2h0.5v1.5h-0.5zM0,-0.5h1v2.5h-1zM-1,1.5h0.5v0.5h-0.5z' },
    { paint: 'cherryBranch', d: 'M-0.5,-1.5h0.5v2.5h-0.5zM-1,1h1v0.5h-1zM-0.5,1.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['cherryPetalPink', 0.8],
        ['cherryTrunk', 0.2],
      ],
      d: 'M2.5,-5h0.5v0.5h-0.5zM1.5,-4.5h2.5v0.5h-2.5zM0,-4h4v0.5h-4zM-2,-3.5h4.5v0.5h-4.5zM3,-3.5h1v0.5h-1zM-4,-3h8v1h-8zM-2,-2h2v0.5h-2zM0.5,-2h2v0.5h-2z',
    },
    {
      paint: 'cherryPetalPink',
      d: 'M-2,-6.5h0.5v0.5h-0.5zM-1,-6.5h1.5v0.5h-1.5zM-3,-6h2.5v0.5h-2.5zM0.5,-6h1.5v0.5h-1.5zM-3,-5.5h0.5v0.5h-0.5zM0,-5.5h2.5v0.5h-2.5zM-4,-5h1v1h-1zM-1.5,-5h4v0.5h-4zM-2.5,-4.5h3v0.5h-3zM1,-4.5h0.5v0.5h-0.5zM-4.5,-4h2.5v1h-2.5zM-1.5,-4h1.5v0.5h-1.5zM2.5,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['blossomWhite', 0.52],
        ['cherryPetalPink', 0.48],
      ],
      d: 'M-0.5,-6h1v0.5h-1zM-2.5,-5.5h2.5v0.5h-2.5zM-3,-5h1.5v0.5h-1.5zM-3,-4.5h0.5v0.5h-0.5zM0.5,-4.5h0.5v0.5h-0.5zM-2,-4h0.5v0.5h-0.5z',
    },
  ],
  pixels: 151,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'cherryTrunk',
      d: 'M0,-4h1v1h-1zM-1.5,-3.5h0.5v0.5h-0.5zM-2,-3h4v0.5h-4zM-1,-2.5h3v0.5h-3zM0,-2h1.5v0.5h-1.5zM0,-1.5h0.5v1h-0.5zM0,-0.5h1v2.5h-1zM-1,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'cherryBranch',
      d: 'M-1.5,-2.5h0.5v0.5h-0.5zM-1,-2h1v0.5h-1zM-0.5,-1.5h0.5v2.5h-0.5zM-1,1h1v0.5h-1zM-0.5,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['cherryPetalPink', 0.83],
        ['cherryTrunk', 0.17],
      ],
      d: 'M1.5,-6h0.5v0.5h-0.5zM1,-5.5h1v0.5h-1zM-2,-5h0.5v1h-0.5zM0,-5h2v0.5h-2zM-4,-4.5h0.5v0.5h-0.5zM-0.5,-4.5h2.5v0.5h-2.5zM3,-4.5h0.5v0.5h-0.5zM-3,-4h2v0.5h-2zM1,-4h0.5v0.5h-0.5zM-4,-3.5h2.5v0.5h-2.5zM2,-3.5h2v0.5h-2zM-3,-3h1v0.5h-1zM2,-3h1.5v0.5h-1.5zM2.5,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'cherryPetalPink',
      d: 'M0,-6.5h1v0.5h-1zM1,-6h0.5v0.5h-0.5zM-0.5,-5.5h1.5v0.5h-1.5zM-3.5,-5h0.5v0.5h-0.5zM-2.5,-5h0.5v0.5h-0.5zM-0.5,-5h0.5v0.5h-0.5zM-3.5,-4.5h1.5v0.5h-1.5zM2,-4.5h1v0.5h-1zM-4,-4h1v0.5h-1zM1.5,-4h2v0.5h-2zM1.5,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['blossomWhite', 0.6],
        ['cherryPetalPink', 0.4],
      ],
      d: 'M0,-6h1v0.5h-1zM-3,-5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 106,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'cherryTrunk',
      d: 'M0,-2h1v0.5h-1zM0,-1.5h0.5v1h-0.5zM0,-0.5h1v2.5h-1zM-1,1.5h0.5v0.5h-0.5z',
    },
    { paint: 'cherryBranch', d: 'M-0.5,-2h0.5v3h-0.5zM-1,1h1v0.5h-1zM-0.5,1.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['cherryPetalWhite', 0.8],
        ['cherryTrunk', 0.2],
      ],
      d: 'M-1.5,-6.5h1v0.5h-1zM0.5,-6.5h0.5v0.5h-0.5zM-3,-6h0.5v0.5h-0.5zM-3.5,-5.5h0.5v0.5h-0.5zM2.5,-5h1v0.5h-1zM1.5,-4.5h2.5v0.5h-2.5zM0,-4h4v0.5h-4zM-2,-3.5h6v0.5h-6zM-4,-3h8v0.5h-8zM-3.5,-2.5h7v0.5h-7zM-1.5,-2h1v0.5h-1zM1,-2h1.5v0.5h-1.5z',
    },
    {
      paint: 'cherryPetalWhite',
      d: 'M-2,-6.5h0.5v0.5h-0.5zM-0.5,-6.5h1v0.5h-1zM-2.5,-6h2v0.5h-2zM0.5,-6h1.5v0.5h-1.5zM-3,-5.5h0.5v0.5h-0.5zM0,-5.5h2.5v0.5h-2.5zM-4,-5h1v1h-1zM-1,-5h3.5v0.5h-3.5zM-2.5,-4.5h3v0.5h-3zM1,-4.5h0.5v0.5h-0.5zM-4.5,-4h2.5v1h-2.5zM-1.5,-4h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['blossomWhite', 0.52],
        ['cherryPetalWhite', 0.48],
      ],
      d: 'M-0.5,-6h1v0.5h-1zM-2.5,-5.5h2.5v0.5h-2.5zM-3,-5h2v0.5h-2zM-3,-4.5h0.5v0.5h-0.5zM0.5,-4.5h0.5v0.5h-0.5zM-2,-4h0.5v0.5h-0.5z',
    },
  ],
  pixels: 152,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
